export default __webpack_public_path__ + "static/media/activity-5.87cf7441.png";